var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['gtp-wrapper', { 'gtp-active': _vm.goToTopBtnActive }],on:{"click":function($event){$event.stopPropagation();return _vm.scrollToTop.apply(null, arguments)}}},[_c('v-icon',[_vm._v("fas fa-arrow-up")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }